import React, { useContext } from 'react'
import QuizSectionTemplate from '../QuizSectionTemplate'
import Explaination from '../Explaination'
import { Flex, Select } from '@mantine/core'
import QuizParameterTemplate from '../QuizParameterTemplate'
import CustomNumberInput from '@components/inputs/quiz/CustomNumberInput'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import accounting from 'accounting'
import BackButton from '../BackButton'
import QuizTooltip from '../QuizTooltip'

const QuizSectionTwo = () => {
    const {
        form2,
        nextStep,
        currentStep,
        years_before_retirement,
        payment_after_retirement_each_year,
        retirement_age,
    } = useContext(QuizContext)
    if (currentStep !== 2) {
        return <></>
    }

    return (
        <form onSubmit={form2!.onSubmit(() => nextStep!())}>
            <Explaination />

            <QuizSectionTemplate section={2} title='ความต้องการในการเกษียณ'>
                <QuizParameterTemplate
                    label='อายุปัจจุบัน'
                    afterLabel='ปี'
                    required
                >
                    <CustomNumberInput
                        min={18}
                        max={64}
                        allowDecimal={false}
                        {...form2!.getInputProps('current_age')}
                    />
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='ปี'
                    label='อายุที่คาดว่าจะเกษียณ'
                    required
                >
                    <QuizTooltip label='ระหว่าง 50 - 65 ปี'>
                        <Select
                            w={200}
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                    textAlign: 'end',
                                },
                            }}
                            data={[
                                { label: '50', value: '50' },
                                { label: '55', value: '55' },
                                { label: '60', value: '60' },
                                { label: '65', value: '65' },
                            ]}
                            min={50}
                            max={65}
                            {...form2!.getInputProps('retirement_age')}
                        />
                    </QuizTooltip>
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='ปี'
                    label='ระยะเวลาก่อนเกษียณ'
                    type='value'
                >
                    {isNaN(years_before_retirement!)
                        ? 0
                        : years_before_retirement}
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    label='ค่าใช้จ่ายหลังเกษียณที่ต้องการ (ไม่ต้องคำนึงถึงเงินเฟ้อ)'
                    description=''
                    afterLabel='บาท/เดือน'
                    required
                >
                    <CustomNumberInput
                        thousandSeparator=','
                        {...form2!.getInputProps(
                            'payment_after_retirement_each_month'
                        )}
                    />
                </QuizParameterTemplate>
                <QuizParameterTemplate
                    afterLabel='บาท/ปี'
                    description={`สมมุติว่าพรุ่งนี้อายุ ${
                        retirement_age! ?? 0
                    } ปี ไม่มีภาระหนี้สินค้างชำระ และไม่ต้องดูแลใครแล้ว รายได้ที่ต้องการ (หรือรายจ่ายที่ต้องใช้) ต่อเดือนเท่าไหร่ ? สำหรับดูแลตัวเอง`}
                    type='value'
                >
                    {accounting.formatMoney(
                        payment_after_retirement_each_year!,
                        {
                            symbol: '',
                            precision: 2,
                        }
                    ) ?? 0}
                </QuizParameterTemplate>
            </QuizSectionTemplate>
            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <BackButton />
                <RoundButton type='submit' label='ถัดไป' />
            </Flex>
        </form>
    )
}

export default QuizSectionTwo
